module.exports = __webpack_public_path__ + "static/media/slide_1-bg.111f8ade.jpg";